import React, { Component } from "react";
import RoomDecorations from "../components/room/roomDecorations";
import RoomRugFilter from "../components/room/roomRugFilter";
import RugAPI from "../api/rug";
import LachakToranjRug from "../components/rug/rugTemplates/lachakToranjRug";
import AfshanRug from "../components/rug/rugTemplates/afshanRug";
import KheshtiRug from "../components/rug/rugTemplates/kheshtiRug";
import ModernRug from "../components/rug/rugTemplates/modernRug";
import Hammer from "hammerjs";
import DecorationItem from "../components/room/decorations/decorationItem";
import RoomRugItem from "../components/room/roomRugItem";
import Footer from '../components/footer';

class RoomLayout extends Component {
  state = {
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: -400,
      y: 200,
    },
    rugWidth: 120,
    rugHeight: 120,

    rugsLoading: false,
    rugsHasNext: true,
    rugs: [],
    rugsOffset: 0,
    selectedRug: null,
    selectedRugsIds: [],
    selectedRugs: {},
    activeRug: null,
    activeId: 0,

    rugFilters: {
      selectedBrands: [],
      selectedShanehs: [],
      selectedDensities: [],
      selectedYarns: [],
      selectedTypes: [],
      selectedColors: [],
      selectedSizes: [],
    },

    selectedDecorations: [],
    selectedDecorationIds: [],

    selectedFloor: null,
    selectedWall: null,
    selectedCeiling: null,
  };

  decorationsCustomSelectHandler = (decorationType, value) => {
    const data = {
      image: value,
      custom: true,
    };
    switch (decorationType) {
      case "wall":
        const wallData = {
          image: value,
          front_image: value,
          right_image: value,
          left_image: value,
          custom: true,
        };
        this.setState({ selectedWall: wallData });
        break;
      case "ceiling":
        this.setState({ selectedCeiling: data });
        break;
      case "floor":
        this.setState({ selectedFloor: data });
        break;
      default:
        break;
    }
  };

  customDecorationsRemoveHandler = (decorationType) => {
    switch (decorationType) {
      case "wall":
        this.setState({ selectedWall: null });
        break;
      case "ceiling":
        this.setState({ selectedCeiling: null });
        break;
      case "floor":
        this.setState({ selectedFloor: null });
        break;
      default:
        break;
    }
  };

  decorationsSelectHandler = (value) => {
    let finalDecorations = [...this.state.selectedDecorations];
    let finalIds = [...this.state.selectedDecorationIds];
    const len = finalDecorations.length;
    finalDecorations = finalDecorations.filter((decoration) => {
      return decoration.id !== value.id;
    });
    if (len === finalDecorations.length) {
      finalDecorations.push(value);
      finalIds.push(value.id);
    } else {
      finalIds.splice(finalIds.indexOf(value.id), 1);
    }
    this.setState({
      selectedDecorations: finalDecorations,
      selectedDecorationIds: finalIds,
    });
  };

  addOrRemoveFromArray = (arr, value) => {
    let finalArray = arr;
    if (arr.indexOf(value) === -1) {
      finalArray.push(value);
    } else {
      finalArray.splice(finalArray.indexOf(value), 1);
    }
    return finalArray;
  };

  filterSelectHandler = (value, filter) => {
    let filters = { ...this.state.rugFilters };
    switch (filter) {
      case "brands":
        filters.selectedBrands = this.addOrRemoveFromArray(
          this.state.rugFilters.selectedBrands,
          value
        );
        break;
      case "shanehs":
        filters.selectedShanehs = this.addOrRemoveFromArray(
          this.state.rugFilters.selectedShanehs,
          value
        );
        break;
      case "densities":
        filters.selectedDensities = this.addOrRemoveFromArray(
          this.state.rugFilters.selectedDensities,
          value
        );
        break;
      case "yarns":
        filters.selectedYarns = this.addOrRemoveFromArray(
          this.state.rugFilters.selectedYarns,
          value
        );
        break;
      case "sizes":
        filters.selectedSizes = this.addOrRemoveFromArray(
          this.state.rugFilters.selectedSizes,
          value
        );
        break;
      default:
        break;
    }
    this.setState({ rugFilters: filters });
    this.loadRugs(filters, false);
  };

  loadRugs = (filters, add = true, offset = 0) => {
    this.setState({ rugsLoading: true });
    if (!add) {
      this.setState({ rugs: [], rugsHasNext: true });
    }

    const api = new RugAPI();
    api
      .getRugs(
        filters.selectedTypes,
        filters.selectedDensities,
        filters.selectedShanehs,
        filters.selectedBrands,
        filters.selectedYarns,
        filters.selectedColors,
        filters.selectedSizes,
        offset
      )
      .then((response) => {
        this.setState({ rugsLoading: false });
        if (response.success) {
          this.setState({
            rugs: add
              ? [...this.state.rugs, ...response.data.results]
              : response.data.results,
            rugsHasNext: !!response.data.next,
          });
        }
      });
  };

  addRugEventLeasteners = (elementId) => {
    const elem = document.getElementById(elementId);
    if (elem) {
      const hammertime = new Hammer(elem);
      hammertime.get("pinch").set({
        enable: true,
      });

      hammertime.on("pinch", (e) => {
        this.setState({ rugHeight: 120 * e.scale, rugWidth: 120 * e.scale });
      });
    }
  };

  componentDidMount() {
    document.title = "دارالفرشه - نمایش سه بعدی";
    this.loadRugs(this.state.rugFilters);
  }

  componentWillUnmount() {
    document.removeEventListener("wheel", this.preventDefault, false);
  }

  wheelHandler = (e, rugKey) => {
    let rugs = { ...this.state.selectedRugs };
    if (e.deltaY < 0) {
      rugs[rugKey].height += 2;
      rugs[rugKey].width += 2;
    } else {
      rugs[rugKey].height -= 2;
      rugs[rugKey].width -= 2;
    }
    this.setState({ selectedRugs: rugs });
  };

  preventDefault = (e) => {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  };

  disableScroll = () => {
    document.addEventListener("wheel", this.preventDefault, {
      passive: false,
    });
  };

  enableScroll = () => {
    document.removeEventListener("wheel", this.preventDefault, false);
  };

  handleDrag = (e, ui) => {
    const { x, y } = this.state.deltaPosition;
    this.setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      },
    });
  };


  roomChangeHandler = (partType, value) => {
    switch (partType) {
      case "floor":
        this.setState({ selectedFloor: value });
        break;
      case "wall":
        this.setState({ selectedWall: value });
        break;
      case "ceiling":
        this.setState({ selectedCeiling: value });
        break;
      default:
        break;
    }
  };

  rugActiveHandler = (rugKey) => {
    this.setState({
      activeRug: rugKey,
      activeId: this.state.selectedRugs[rugKey].rug.id,
    });
  };

  addRugHandler = () => {
    const keys = Object.keys(this.state.selectedRugs);
    if (keys.length < 4 && keys.length !== 0) {
      let newRugs = { ...this.state.selectedRugs };
      const key = "rug" + keys.length + 1;
      newRugs[key] = { ...newRugs[keys[keys.length - 1]] };
      this.setState({ selectedRugs: newRugs, activeRug: key });
    }
  };

  rugSelectHandler = (rug) => {
    // console.log(this.state.selectedRugs);
    let newRugs = { ...this.state.selectedRugs };
    let activeRug = this.state.activeRug;
    let activeId = rug.id;
    if (!this.state.activeRug) {
      // create new
      const key = "rug" + (Object.keys(this.state.selectedRugs).length + 1);
      newRugs[key] = { rug: rug, height: 120, width: 120 };
      activeRug = key;
    } else if (rug.id === newRugs[activeRug].rug.id) {
      delete newRugs[activeRug];
      const keys = Object.keys(newRugs);
      activeRug = keys.length === 0 ? null : keys[0];
      activeId = !activeRug ? 0 : newRugs[activeRug].rug.id;
    } else {
      // update
      newRugs[this.state.activeRug].rug = rug;
    }
    this.setState({
      selectedRugs: newRugs,
      activeRug: activeRug,
      activeId: activeId,
    });
  };

  getRugComponent = (rug, rugKey) => {
    const rugData = rugKey ? this.state.selectedRugs[rugKey] : rug;
    if (rugData.full_image) {
      return <img className="single-img" src={rug.full_image} alt="Rug" />;
    }
    switch (rugData.rug_type) {
      case "lachak-toranj":
        return (
          <LachakToranjRug
            background={rugData.background}
            border={rugData.border}
            corner={rugData.corner}
            toranj={rugData.toranj}
            show={true}
          />
        );
      case "afshan":
        return (
          <AfshanRug
            background={rugData.background}
            border={rugData.border}
            show={true}
          />
        );
      case "kheshti":
        return (
          <KheshtiRug
            background={rugData.background}
            tile={rug.tile}
            show={true}
          />
        );
      case "modern":
        return (
          <ModernRug
            background={rugData.background}
            pattern={rugData.pattern}
            show={true}
          />
        );
      default:
        return <div></div>;
    }
  };

  render() {
    return (
      <div className="room-generator">
        <RoomRugFilter
          filters={this.state.rugFilters}
          selectHandler={this.filterSelectHandler}
          getRugComponent={this.getRugComponent}
          rugs={this.state.rugs}
          loadRugs={this.loadRugs}
          rugFilters={this.state.rugFilters}
          rugsHasNext={this.state.rugsHasNext}
          rugSelectHandler={this.rugSelectHandler}
          selectedRug={this.state.selectedRug}
          selectedRugs={this.state.selectedRugs}
          selectedIds={this.state.selectedRugsIds}
          activeId={this.state.activeId}
          rugsLoading={this.state.rugsLoading}
		  addRugHandler={this.addRugHandler}
		  texts={this.props.texts}
        />

        {/* pop up page loader for show add className active */}
        <div className="clear-both text-center p-3 page-loader">
          <h3>{this.props.texts["loading"]}</h3>
        </div>

        <div className="w-100 main-images-page">
          {/* when you try to use a single background pls add pb-0 className to parent div (top line)  */}
          {/* <img className="single-background" src="/static/img/3D-backgrounddark.png" alt="" /> */}

          {/* walls and floor */}
          <img
            className={
              this.state.selectedCeiling
                ? "ceiling-image"
                : "ceiling-image wall-ceiling-default"
            }
            style={
              this.state.selectedCeiling
                ? { backgroundColor: this.state.selectedCeiling.color_code }
                : {}
            }
            src={
              this.state.selectedCeiling ? this.state.selectedCeiling.image : ""
            }
            alt="Ceiling"
          />
          <img
            className={
              this.state.selectedWall
                ? "flow-wall"
                : "flow-wall wall-main-default"
            }
            style={{
              backgroundImage:
                "url(" +
                (this.state.selectedWall
                  ? this.state.selectedWall.front_image
                  : "") +
                ")",
            }}
            alt=""
          />
          <img
            className={
              this.state.selectedFloor
                ? "floor-image"
                : "floor-image wall-floor-default"
            }
            style={{
              backgroundImage:
                "url(" +
                (this.state.selectedFloor
                  ? this.state.selectedFloor.image
                  : "") +
                ")",
            }}
            alt="Floor"
          />
          <img
            className={
              this.state.selectedWall
                ? "right-image"
                : "right-image wall-right-default"
            }
            style={{
              backgroundImage:
                "url(" +
                (this.state.selectedWall
                  ? this.state.selectedWall.right_image
                  : "") +
                ")",
            }}
            alt="Right Wall"
          />
          <img
            className={
              this.state.selectedWall
                ? "left-image"
                : "left-image wall-left-default"
            }
            style={{
              backgroundImage:
                "url(" +
                (this.state.selectedWall
                  ? this.state.selectedWall.left_image
                  : "") +
                ")",
            }}
            alt=""
          />

          {/* this body carpet for test */}
          {/*   baraye DEFAULT class e body-carpet-default be div e payini add kon  */}
          <div
            className={
              this.state.selectedRug
                ? "body-carpet"
                : "body-carpet body-carpet-default"
            }
          >
            {Object.keys(this.state.selectedRugs).length > 0 &&
              Object.keys(this.state.selectedRugs).map((k) => (
                <RoomRugItem
                  rug={this.state.selectedRugs[k]}
				  key={"roomRug" + k}
				  rugKey={k}
				  activeHandler={this.rugActiveHandler}
				  texts={this.props.texts}
                />
              ))}
          </div>

          {this.state.selectedDecorations.map((decoration) => (
            <DecorationItem
              decoration={decoration}
			  key={"decorationImage" + decoration.id}
            />
          ))}
        </div>

        <RoomDecorations
          decorationsSelectHandler={this.decorationsSelectHandler}
          decorationsCustomSelectHandler={this.decorationsCustomSelectHandler}
          customDecorationsRemoveHandler={this.customDecorationsRemoveHandler}
          selectedDecorations={this.state.selectedDecorationIds}
          roomPartsSelectHandler={this.roomChangeHandler}
          selectedFloor={this.state.selectedFloor}
          selectedWall={this.state.selectedWall}
		  selectedCeiling={this.state.selectedCeiling}
		  texts={this.props.texts}
        />
        <Footer />
      </div>
    );
  }
}

export default RoomLayout;
